import React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  ChipField,
  ReferenceField,
  TopToolbar,
  CreateButton,
  ExportButton,
  Filter,
  TextInput,
  SelectInput,
  DateInput,
} from "react-admin";

const subscriptionStatuses = [
  { id: "active", name: "Активна" },
  { id: "expired", name: "Истекла" },
  { id: "cancelled", name: "Отменена" },
  { id: "suspended", name: "Приостановлена" },
  { id: "pending", name: "Ожидает" },
];

const UserSubscriptionFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="ID пользователя" source="userId" alwaysOn />
    <SelectInput
      label="Статус"
      source="status"
      choices={subscriptionStatuses}
      alwaysOn
    />
    <DateInput label="Дата начала" source="startDate" />
    <DateInput label="Дата окончания" source="endDate" />
  </Filter>
);

const UserSubscriptionListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const UserSubscriptionList = () => {
  return (
    <List
      actions={<UserSubscriptionListActions />}
      filters={<UserSubscriptionFilter />}
      title="Подписки пользователей"
    >
      <Datagrid rowClick="show">
        <ReferenceField source="userId" reference="users" label="Пользователь">
          <TextField source="email" />
        </ReferenceField>
        <ReferenceField
          source="subscriptionPlanId"
          reference="subscriptionPlans"
          label="План подписки"
        >
          <TextField source="name" />
        </ReferenceField>
        <ChipField source="status" label="Статус" />
        <DateField source="startDate" label="Начало" />
        <DateField source="endDate" label="Окончание" />
        <NumberField
          source="amountPaid"
          label="Оплачено"
          options={{ style: "currency", currency: "USD" }}
        />
        <TextField source="currency" label="Валюта" />
        <BooleanField source="autoRenew" label="Автопродление" />
        <DateField source="createdAt" label="Создана" showTime />
        <EditButton />
        <ShowButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
